// SPDX-FileCopyrightText: 2026 Angels' Ware
// SPDX-License-Identifier: AGPL-3.0-or-later

// The site footer, under the prev/next pair at the foot of every page.
//
// A reference site ends somewhere, and this one used to just stop at whatever
// the last table happened to be — which reads as an internal build, and leaves
// the two questions a reader most often has at the bottom of a docs page (what
// is this thing, where do I get it) with nowhere to land.
//
// The link columns are DERIVED FROM NAV, the same decision ORDER makes in
// content.ts: a footer listing its own copy of the sidebar is a second list to
// keep in step, and it fails by quietly pointing at a page that moved. Only the
// off-site links are written out here.
import { Link } from "react-router-dom";
import { NAV } from "./content";
import { SITE, SOURCE, LICENSE, CONTACT, INVITE } from "./links";
import { COPYRIGHT_YEAR } from "../lib/externalLinks";

const GUIDE = NAV[0].items.slice(0, 5);
const REFERENCE = [...NAV[0].items.slice(5), ...NAV[1].items.slice(0, 1)];

export function DocsFooter() {
  return (
    <footer className="docs-footer">
      <div className="docs-footer-main">
        <div className="docs-footer-brand">
          <span className="docs-footer-mark">
            <img src="/logo.svg" alt="" width={22} height={22} draggable={false} />
            <span className="docs-footer-name">Dazyflow</span>
          </span>
          <p className="docs-footer-blurb">
            Build automations without code — connect your apps and let the repetitive work
            run itself.
          </p>
        </div>

        <nav className="docs-footer-cols" aria-label="Footer">
          <div className="docs-footer-col">
            <h2 className="docs-footer-heading">Guide</h2>
            {GUIDE.map((i) => (
              <Link key={i.link} className="docs-footer-link" to={i.link}>
                {i.text}
              </Link>
            ))}
          </div>

          <div className="docs-footer-col">
            <h2 className="docs-footer-heading">Reference</h2>
            {REFERENCE.map((i) => (
              <Link key={i.link} className="docs-footer-link" to={i.link}>
                {i.text}
              </Link>
            ))}
          </div>

          <div className="docs-footer-col">
            <h2 className="docs-footer-heading">Project</h2>
            {/* Off-site, so plain anchors with the same treatment the Markdown
                renderer gives an external link. */}
            <a className="docs-footer-link" href={SITE}>
              Product site
            </a>
            <a className="docs-footer-link" href={SOURCE}>
              Source code
            </a>
            <a className="docs-footer-link" href={LICENSE}>
              License
            </a>
            <a className="docs-footer-link" href={CONTACT}>
              Contact
            </a>
            <a className="docs-footer-link" href={INVITE}>
              Request an invite
            </a>
          </div>
        </nav>
      </div>

      <div className="docs-footer-legal">
        <span>© {COPYRIGHT_YEAR} Angels' Ware</span>
        {/* Named in full rather than as a bare "AGPL" badge: the licence is the
            reason self-hosting is an option at all, and the version is the part
            that carries the obligation. */}
        <span>
          Free software under the{" "}
          <a className="docs-footer-legal-link" href={LICENSE}>
            GNU AGPL v3
          </a>
        </span>
      </div>
    </footer>
  );
}
